import * as React from "react";
import NoResultsOverlay from "../NoResultsOverlay";
import { Button, ButtonGroup, FilterList } from "@conserveit/blocks";
import { IssueListItem } from "./components/IssueListItem";
import { IssueDetails } from "./components/IssueDetails";

import {
  Content,
  Left,
  Right,
  Footer,
  IssuesContainer,
  IssueList,
} from "./AssociateIssueSelect.styles";

interface Props {
  issues: Insite.API.Action[];
  isAssociating: boolean;
  equipRuleIds: number[];
  associateEquipRule(equipRuleIds: number[], issueKey: string): void;
  onHide(): void;
}

interface State {
  selected?: Insite.API.Action;
}

export class AssociateIssueSelect extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selected: undefined,
    };
  }

  handleSelectIssue = (issue: Insite.API.Action) => () => {
    this.setState({
      selected: issue,
    });
  };

  handleAssociateToIssue = () => {
    // NOTE: The button that calls this handler is only enabled when selected is
    // defined. Asserting non-null as a result
    this.props.associateEquipRule(
      this.props.equipRuleIds,
      this.state.selected!.key
    );
  };

  render() {
    return (
      <React.Fragment>
        <Content>
          <Left>
            <IssuesContainer>
              <FilterList
                items={this.props.issues}
                filterKey="valueString"
                placeholder="Filter items..."
              >
                {({ visible }) => (
                  <IssueList noResults={visible.length === 0}>
                    {visible.length === 0 ? (
                      <NoResultsOverlay noResultsMessage />
                    ) : (
                      visible.map((issue) => (
                        <IssueListItem
                          key={issue.key}
                          issue={issue}
                          isSelected={
                            this.state.selected !== undefined &&
                            this.state.selected.key === issue.key
                          }
                          onSelect={this.handleSelectIssue(issue)}
                        />
                      ))
                    )}
                  </IssueList>
                )}
              </FilterList>
            </IssuesContainer>
          </Left>
          <Right>
            <IssueDetails issue={this.state.selected} />
          </Right>
        </Content>
        <Footer>
          <ButtonGroup>
            <Button appearance="plain" onClick={this.props.onHide}>
              Cancel
            </Button>
            <Button
              primary
              disabled={
                this.state.selected === undefined || this.props.isAssociating
              }
              onClick={this.handleAssociateToIssue}
            >
              Associate
            </Button>
          </ButtonGroup>
        </Footer>
      </React.Fragment>
    );
  }
}
